import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "minRows", "maxRows", "inputRef", "size", "value", "width", "invalid"];
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import cx from 'classnames';
import { useInputSize } from '../../../internal/hooks';
import { TextareaAutosize } from '../../internal/components';
import { getStyles } from './styles';

/**
 * Компонент textarea.
 * Автоматически подстраивает свою высоту под количество введеного текста.
 */
export var Textarea = /*#__PURE__*/React.forwardRef(function Textarea(props, ref) {
  var onChange = props.onChange,
    minRows = props.minRows,
    maxRows = props.maxRows,
    inputRefProp = props.inputRef,
    sizeProp = props.size,
    value = props.value,
    width = props.width,
    invalid = props.invalid,
    rest = _objectWithoutProperties(props, _excluded);
  var handleRef = useForkRef(ref, inputRefProp);
  var size = useInputSize(sizeProp);
  var styles = getStyles(size);
  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e, e.currentTarget.value);
    }
  };
  return /*#__PURE__*/React.createElement(TextareaAutosize, _extends({}, rest, {
    ref: handleRef,
    value: value,
    className: cx(styles['textarea'], invalid && styles['invalid']),
    onChange: handleChange,
    minRows: minRows,
    maxRows: maxRows,
    style: {
      width: width
    }
  }));
});